<template>
  <v-card-text>


    <v-row>
      <v-col cols="12" md="12" sm="12">
        <GMapViewer
  :apiKey="'AIzaSyBDZQUtQQjIrF2Vus_zv5XRnFBB1-fun50'"
  :perimeter="false"
  :points="item.asus.locations"
  :locations="[
    { id: 1, name: 'São Paulo', address: 'São Paulo, SP', lat: -23.55, lng: -46.63 },
    { id: 2, name: 'Minas Gerais', address: 'Minas Gerais', lat: -18.10, lng: -44.38 },
    { id: 3, name: 'Rio de Janeiro', address: 'Rio de Janeiro', lat: -22.90, lng: -43.20 }
  ]"
/>
      </v-col>
    </v-row>
  </v-card-text>
</template>
<script>
import GMapViewer from "@/interface/GMapViewer.vue";
import jsFunctions from "@/plugins/helper";
export default {
  components: {
    GMapViewer
  },
  data() {
    return {
      textSearch: "",
      allLocations: [],
      filteredLocations: [],
      center: {
        lat: 0,
        lng: 0,
      },
      loading: true,
      markers: [],
    };
  },
  props: {
    item: Object,
  },
  computed: {},
  watch: {
    textSearch: {
      deep: true,
      handler() {
        this.search();
      },
    },
  },
  mounted() {
    this.locations();
    // setTimeout(() => {
    // }, 300);
  },
  methods: {
    search() {
      const newVal = this.textSearch;
      if (!newVal) {
        this.filteredLocations = this.allLocations;
      } else {
        this.filteredLocations = this.allLocations.filter((string) => {
          return jsFunctions
            .accentsTidy(string.label)
            .includes(jsFunctions.accentsTidy(newVal));
        });
      }
      setTimeout(() => {
        this.scanMarkers();
      }, 300);
    },
    onScroll() {
      this.scrollInvoked++;
    },
    locations() {
      let result = [];
      let pop = "";
      let locations = this.item.asus.locations;
      locations.forEach((localization) => {
        let res = "";
        if (localization.original) {
          let location = localization.original;
          if (location.street) res = location.street;
          if (location.district)
            res += res ? `, ${location.district}` : location.district;
          if (location.region) {
            if (location.region.population) pop = location.region.population;

            if (location.region.city && location.region.city.long_name)
              res += res
                ? ` - ${location.region.city.long_name}`
                : location.region.city.long_name;
            if (location.region.state && location.region.state.short_name)
              res += res
                ? ` - ${location.region.state.short_name}`
                : location.region.city.short_name;
            if (location.region.country && location.region.country.long_name)
              res += res
                ? ` - ${location.region.country.long_name}`
                : location.region.country.long_name;
          }
        }
        result.push({ label: res, population: pop, object: localization });
      });
      this.allLocations = result;
      this.search();
    },
    scanMarkers() {
      const google = window.google;

      this.loading = true;

      let result = { items: [], unrecognized: 0 };
      var b = new google.maps.LatLngBounds();

      this.filteredLocations.forEach((item) => {
        let loc = item.object;
        console.log("loc", loc);
        if (loc.coordinates && loc.coordinates.length == 2) {
          b.extend({
            lat: loc.coordinates[1],
            lng: loc.coordinates[0],
          });
          result.items.push({
            position: { lat: loc.coordinates[1], lng: loc.coordinates[0] },
          });
        } else result.unrecognized++;
      });
      this.markers = result.items;
      this.loading = false;
      // setTimeout(() => {
        // this.$refs.mmm.fitBounds(b);
      // }, 1000);
    },
  },
};
</script>